import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const comunicadosRoutes: Routes = [
  {
    path: 'comunicados',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Área de Comunicados e Informes',
      breadcrumb: [{ label: 'Área de Comunicados e Informes' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./comunicados.component').then((m) => m.ComunicadosComponent),
        data: {
          title: 'Área de Comunicados e Informes',
          roles: [Role.COMUNICADO_VISUALIZAR],
          breadcrumb: [{ label: 'Área de Comunicados e Informes', url: '/comunicados' }],
        },
      },
      {
        path: 'cadastrar',
        data: {
          title: 'Cadastrar Comunicado',
          roles: [Role.COMUNICADO_CRIAR],
          breadcrumb: [
            { label: 'Área de Comunicados e Informes', url: '/comunicados' },
            { label: 'Cadastrar', url: '/comunicados/cadastrar' },
          ],
        },
        loadComponent: () =>
          import('./comunicado-form/comunicado-form.component').then(
            (m) => m.ComunicadoFormComponent,
          ),
      },
      {
        path: 'editar/:id',
        data: {
          title: 'Editar Comunicado',
          roles: [Role.COMUNICADO_EDITAR],
          breadcrumb: [
            { label: 'Área de Comunicados e Informes', url: '/comunicados' },
            { label: 'Editar', url: '/comunicados/editar' },
          ],
        },
        loadComponent: () =>
          import('./comunicado-form/comunicado-form.component').then(
            (m) => m.ComunicadoFormComponent,
          ),
      },
      {
        path: 'visualizar/:id',
        data: {
          title: 'Visualizar Comunicado',
          roles: [Role.COMUNICADO_VISUALIZAR],
          breadcrumb: [
            { label: 'Área de Comunicados e Informes', url: '/comunicados' },
            { label: 'Visualizar', url: '/comunicados/visualizar' },
          ],
        },
        loadComponent: () =>
          import('./comunicado-form/comunicado-form.component').then(
            (m) => m.ComunicadoFormComponent,
          ),
      },
    ],
  },
];
